module.exports = __webpack_public_path__ + "img/credit-cards.c67dbba9.svg";